import {
    SET_ASSET_ORDER_DETAIL_ATTACHMENTS,
    SET_ASSET_ORDER_DETAIL_LINKED_ATTACHMENTS,
    SET_BILL_OF_SALE_URL,
    SET_IS_BILL_OF_SALE_CREATED
} from "./BillOfSaleType";

const initialState = {
    assetOrderDetailAttachments: [],
    assetOrderDetailLinkedAttachments: [],
    isBillOfSaleCreated: false,
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_ORDER_DETAIL_ATTACHMENTS:
            return {
                ...state,
                assetOrderDetailAttachments: action.list,
            };
        case SET_ASSET_ORDER_DETAIL_LINKED_ATTACHMENTS:
            return {
                ...state,
                assetOrderDetailLinkedAttachments: action.linkedList,
            };
        case SET_BILL_OF_SALE_URL:
            return {
                ...state,
                billOfSaleUrl: action.url,
            }
        case SET_IS_BILL_OF_SALE_CREATED:
            return {
                ...state,
                isBillOfSaleCreated: action.isBillOfSaleCreated,
            };
        default:
            return state;
    }
};

export default reducer;
